const MODULE_ID = 'forms';
export default MODULE_ID;
